import { useQuery } from '@tanstack/react-query'
import { listLocationOverrideRules } from '../../../../../api/plan-location-override-rules-api'
import type { ListPlanLocationOverrideRulesQueryDto } from '../../../../../api/dto/plan-location-override-rules.dto'

export const LOCATION_OVERRIDE_RULES_QUERY_KEY = 'locationOverrideRules'

export function useGetLocationOverrideRules(
  params: ListPlanLocationOverrideRulesQueryDto
) {
  const { data, isLoading, error } = useQuery({
    queryKey: [LOCATION_OVERRIDE_RULES_QUERY_KEY, params],
    queryFn: () => listLocationOverrideRules(params),
    staleTime: 30_000,
  })

  return {
    items: data?.data ?? [],
    total: data?.meta.total ?? 0,
    page: data?.meta.page ?? 1,
    limit: data?.meta.limit ?? 20,
    totalPages: data?.meta.totalPages ?? 0,
    isLoading,
    error,
  }
}
